export default __webpack_public_path__ + "static/media/log-out.ef4f2554.svg";